import {
   rand,
   randNumber,
   randUuid,
   randCatchPhrase,
   randCompanyName,
   randRecentDate,
   randFullName,
   randLine,
} from '@ngneat/falso';
import { randomArray, optional } from '@library/common/functions';

import { MockAttachment } from '@library/common/models/mock';
import { MockCartageCharge } from '../models/mock/cartage-charge.mock';
import { MockCartagePod } from '../models/mock/cartage-pod.mock';
import { MockCartageStatus } from '../models/mock/cartage-status.mock';

import { BulkUpdateTypes } from '../update';

import { BulkQueue, BulkQueueJob } from './bulk-queue';

export class MockBulkQueue extends BulkQueue {
   constructor( type?: BulkUpdateTypes ) {
      super({
         id: randUuid(),
         label: randCatchPhrase(),

         user: randFullName(),
         account: randCompanyName(),
         uploaded: randRecentDate(),

         actionType: type || rand([ ...BulkUpdateTypes ]),
         actions: [],
         jobs: randomArray( MockBulkQueueJob, 20, 1 ),
      });

      this.actions = getAction( this.actionType );
   }
}

function getAction( type: BulkUpdateTypes = BulkUpdateTypes[0] ): any[] {
   switch ( type ) {
      case 'driver':
         return [ randFullName() ];
      case 'status':
         return randomArray( MockCartageStatus, 3, 1 );
      case 'manifest':
         return [ new MockAttachment() ];
      case 'attachment':
         return randomArray( MockAttachment, 10, 1 );
      case 'note':
         return [ randLine({ lineCount: 7 }) ];
      case 'pod':
         return [ new MockCartagePod() ];
      case 'charge':
         return randomArray( MockCartageCharge, 10, 1 );
   }
}

export class MockBulkQueueJob extends BulkQueueJob {
   constructor() {
      super({
         job: randNumber({ max: 999999999 }),
         completed: optional( 70 ),
         error: optional( 30 ),
      });
   }
}
